// ColumnSorter.tsx
import { Column } from "@tanstack/react-table";
import { ActionIcon } from "@mantine/core";
import styles from "@scss/custom-components/sort-and-filter.module.scss";

export interface ColumnButtonProps {
  column: Column<any, any>;
}

export const CustomColumnSorter: React.FC<ColumnButtonProps> = ({ column }) => {
  if (!column.getCanSort()) return null;

  const sorted = column.getIsSorted(); // false | "asc" | "desc"

  const className = [
    styles.sortButton, // always keep base
    sorted ? styles["sortButton--sorted"] : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <ActionIcon
      size="xs"
      onClick={column.getToggleSortingHandler()}
      className={className}
    >
      <div className={styles.iconContainer}>
        <></>
      </div>
    </ActionIcon>
  );
};
